export default __webpack_public_path__ + "static/media/fledgling-logo.84e3eb48.svg";